import { Avatar as ChakraAvatar } from '@chakra-ui/react';

type Props = ChakraAvatar.RootProps;
export type AvatarProps = Props;

const AvatarRoot: React.FC<Props> = (props) => {
  return <ChakraAvatar.Root {...props} />;
};

export const Avatar = Object.assign(AvatarRoot, {
  Root: ChakraAvatar.Root,
  Image: ChakraAvatar.Image,
  Fallback: ChakraAvatar.Fallback,
});
